class headerJS {
  constructor() {
    this.selectors = {
      activeClass: "active",
      menuToggleHeader: "data-menu-toggle-header",
      menuToggleContent: "data-menu-toggle-content",
      menuToggleHeight: "data-toogle-height"
    }
    this.mainNavigation = document.getElementsByClassName('menu-drawer__inner-container')[0];
    this.menuHeader = document.getElementById('header_desktop');
    this.headerCloseIcon = document.getElementById('header_icon');
    this.EventHandle();
  }

  EventHandle() {
    let _this = this;
    this.toggleMegaMenu();
    this.toggleLanguageMenuMobile();
    this.clearSearchField();

    /*window.addEventListener('click', function (e) {

      if (e.target.closest("#menu-drawer") == document.getElementById("menu-drawer") || e.target == document.getElementById("#menu-drawer")) {
      } else if (e.target.closest("[data-menu-toggle-content]") == document.querySelector("[data-menu-toggle-content=\"content_mega_menu_1\"]") || e.target == document.querySelector("[data-menu-toggle-content=\"content_mega_menu_1\"]")) {
      } else if (e.target.closest("[data-menu-toggle-content]") == document.querySelector("[data-menu-toggle-content=\"content_mega_menu_2\"]") || e.target == document.querySelector("[data-menu-toggle-content=\"content_mega_menu_2\"]")) {
      } else if (e.target.closest("[data-menu-toggle-content]") == document.querySelector("[data-menu-toggle-content=\"content_mega_menu_3\"]") || e.target == document.querySelector("[data-menu-toggle-content=\"content_mega_menu_2\"]")) {
      } else if (e.target.closest("[data-menu-toggle-header]") == document.querySelector("[data-menu-toggle-header=\"content_mega_menu_1\"]") || e.target == document.querySelector("[data-menu-toggle-header=\"content_mega_menu_1\"]")) {
      } else if (e.target.closest("[data-menu-toggle-header]") == document.querySelector("[data-menu-toggle-header=\"content_mega_menu_2\"]") || e.target == document.querySelector("[data-menu-toggle-header=\"content_mega_menu_2\"]")) {
      } else if (e.target.closest("[data-menu-toggle-header]") == document.querySelector("[data-menu-toggle-header=\"content_mega_menu_3\"]") || e.target == document.querySelector("[data-menu-toggle-header=\"content_mega_menu_3\"]")) {
      } else {
         _this.removeActiveToggleContent();
      }
    });*/

    window.addEventListener('resize', function (e) {
      _this.removeActiveToggleContent();
    });
  }

  calcHeaderVisibility(isLanguageTabOpen) {
    let _this = this;
    let isSubmenuOpen = false;
    if (_this.mainNavigation) {
      isSubmenuOpen = _this.mainNavigation.classList.contains('is-submenu-opening');
    }

    if (isLanguageTabOpen || isSubmenuOpen) {
      if (_this.menuHeader) {
        _this.menuHeader.classList.add('hide-on-mobile');
      }
      if (_this.headerCloseIcon) {
        _this.headerCloseIcon.classList.add('hide-on-mobile');
      }
    } else {
      if (_this.menuHeader) {
        _this.menuHeader.classList.remove('hide-on-mobile');
      }
      if (_this.headerCloseIcon) {
        _this.headerCloseIcon.classList.remove('hide-on-mobile');
      }
    }
  }

  removeActiveToggleContent(currentName) {
    let allToggleContents = document.querySelectorAll("["+this.selectors.menuToggleContent+"]");
    if (allToggleContents.length > 0) {
      for (let i = 0; i < allToggleContents.length;i++){
        let allToggleContent = allToggleContents[i];
        let toggleContentName = allToggleContent.getAttribute(this.selectors.menuToggleContent);

        if (allToggleContent && allToggleContent.classList.contains(this.selectors.activeClass) && toggleContentName !== currentName) {
          allToggleContent.classList.remove(this.selectors.activeClass);
          this.calcHeaderVisibility(false);
          allToggleContent.style.height = "0px";
        }

        if(allToggleContent.querySelector('predictive-search')) {
          allToggleContent.querySelector('predictive-search').removeAttribute('open');
        }
      }
    }

    let allToggleHeaders = document.querySelectorAll("["+this.selectors.menuToggleHeader+"]");
    if (allToggleHeaders.length > 0) {
      for (let i = 0; i < allToggleHeaders.length;i++){
        let allToggleHeader = allToggleHeaders[i];
        let toggleHeaderName = allToggleHeader.getAttribute(this.selectors.menuToggleHeader);

        if (allToggleHeader && allToggleHeader.classList.contains(this.selectors.activeClass) && toggleHeaderName !== currentName) {
          allToggleHeader.classList.remove(this.selectors.activeClass);
          this.calcHeaderVisibility(false);
        }
      }
    }
  }

  toggleLanguageMenuMobile() {

    let _this = this;
    let triggerElements = document.querySelectorAll("a[data-menu-toggle-header=\"content_mobile_menu_2\"]");
    if (triggerElements.length > 0 ) {

      for (let i = 0;i<triggerElements.length;i++) {
        let item = triggerElements[i];

        if (item) {

          item.addEventListener("click", function (e) {
          e.preventDefault();

          let content = document.querySelector("[data-menu-toggle-content=\"content_mobile_menu_2\"]");
          if (content) {

            // _this.removeActiveToggleContent(toggleContentName);
            let menuDrawerBottoms = document.getElementsByClassName("menu-drawer__container--bottom");
            let heightMenuDrawerBottom = 56;
            if (menuDrawerBottoms.length > 0) {
              for (let k = 0; k < menuDrawerBottoms.length; k++) {
                let menuDrawerBottom = menuDrawerBottoms[k];
                if (menuDrawerBottom.offsetHeight > 0) {
                  heightMenuDrawerBottom = menuDrawerBottom.offsetHeight;
                }
              }
            }

            let isLanguageTabOpen = content.classList.toggle(_this.selectors.activeClass);
            _this.calcHeaderVisibility(isLanguageTabOpen);

            if (content.classList.contains(_this.selectors.activeClass) && content.querySelector("["+_this.selectors.menuToggleHeight+"]") && content.querySelector("["+_this.selectors.menuToggleHeight+"]").offsetHeight > 0) {
              let cssHeight = "calc(100% - " + heightMenuDrawerBottom + "px)";

              let gBCR = content.getBoundingClientRect();
              let contentHeight = content.querySelector("[" + _this.selectors.menuToggleHeight + "]").offsetHeight;
              let result = gBCR.top + contentHeight;
              content.classList.add("use-not-menu-bottom");

              if (screen.height < result) {
                cssHeight = contentHeight;
                cssHeight += "px";
                content.classList.remove("use-not-menu-bottom");
              }
              content.style.height = cssHeight; // content.querySelector("[" + _this.selectors.menuToggleHeight + "]").offsetHeight + "px"
            } else {
              if (content.classList.contains("use-not-menu-bottom")) {
                content.classList.add("use-not-menu-bottom");
              }
              content.style.height = "0px"
            }
          }

        });

        }
      }
    }
  }

  toggleMegaMenu() {

    let _this = this;
    let activeClassSelector = this.selectors.activeClass;
    let toggleMenuElements = document.querySelectorAll("div["+this.selectors.menuToggleHeader+"]");
    if (toggleMenuElements.length > 0) {
      for (let i = 0; i < toggleMenuElements.length;i++){
        let toggleMenuElement = toggleMenuElements[i];
        if (toggleMenuElement) {
          toggleMenuElement.addEventListener("click", function (e) {

            let isLanguageTabOpen = toggleMenuElement.classList.toggle(activeClassSelector);
            _this.calcHeaderVisibility(isLanguageTabOpen);

            if (e && e.currentTarget) {
              let toggleContentName = e.currentTarget.getAttribute(_this.selectors.menuToggleHeader);
              let currentContent = document.querySelector("["+_this.selectors.menuToggleContent+"=\"" + toggleContentName + "\"]");
              if (currentContent) {

                _this.removeActiveToggleContent(toggleContentName);
                let isLanguageTabOpen = currentContent.classList.toggle(activeClassSelector);
                _this.calcHeaderVisibility(isLanguageTabOpen);

                if (currentContent.classList.contains(activeClassSelector) && currentContent.querySelector("["+_this.selectors.menuToggleHeight+"]") && currentContent.querySelector("["+_this.selectors.menuToggleHeight+"]").offsetHeight > 0) {
                  currentContent.style.height = currentContent.querySelector("["+_this.selectors.menuToggleHeight+"]").offsetHeight + "px"
                } else {
                  currentContent.style.height = "0px"
                }
                window.scrollTo(0,0);
              }
            }
          });
        }
      }
    }
  }


  clearSearchField() {

    const closeButtonElements = Array.from(document.getElementsByClassName("remove-search-input-js"));
    if (closeButtonElements.length === 0) { return false };
    for (let element of closeButtonElements) {
      element.addEventListener("click", function (e) {
        if (!e.target) { return false; }
        e.target.closest(".search__content-toogle").querySelector(".search__input").value = "";
      });
    }
  }
}
const headerStart = new headerJS();